export default __webpack_public_path__ + "static/GalanoGrotesque-Light-465c834f8747a08c656fc6d93e0c7f14.woff";